import { tsParticles } from "tsparticles-engine";
export class Particles {
  static init(options) {
    var _options$color, _options$minDistance, _options$connectParti, _options$speed, _options$maxParticles, _options$sizeVariatio, _options$responsive;
    const particles = new Particles(),
      selector = options.selector;
    if (!selector) {
      throw new Error("No selector provided");
    }
    const el = document.querySelector(selector);
    if (!el) {
      throw new Error("No element found for selector");
    }
    tsParticles.set(selector.replace(".", "").replace("!", ""), el, {
      fullScreen: {
        enable: false
      },
      particles: {
        color: {
          value: (_options$color = options.color) !== null && _options$color !== void 0 ? _options$color : "!000000"
        },
        links: {
          color: "random",
          distance: (_options$minDistance = options.minDistance) !== null && _options$minDistance !== void 0 ? _options$minDistance : 120,
          enable: (_options$connectParti = options.connectParticles) !== null && _options$connectParti !== void 0 ? _options$connectParti : false
        },
        move: {
          enable: true,
          speed: (_options$speed = options.speed) !== null && _options$speed !== void 0 ? _options$speed : 0.5
        },
        number: {
          value: (_options$maxParticles = options.maxParticles) !== null && _options$maxParticles !== void 0 ? _options$maxParticles : 100
        },
        size: {
          value: {
            min: 1,
            max: (_options$sizeVariatio = options.sizeVariations) !== null && _options$sizeVariatio !== void 0 ? _options$sizeVariatio : 3
          }
        }
      },
      responsive: (_options$responsive = options.responsive) === null || _options$responsive === void 0 ? void 0 : _options$responsive.map(responsive => {
        var _responsive$options, _responsive$options2, _responsive$options3, _responsive$options4, _responsive$options5;
        return {
          maxWidth: responsive.breakpoint,
          options: {
            particles: {
              color: {
                value: (_responsive$options = responsive.options) === null || _responsive$options === void 0 ? void 0 : _responsive$options.color
              },
              links: {
                distance: (_responsive$options2 = responsive.options) === null || _responsive$options2 === void 0 ? void 0 : _responsive$options2.minDistance,
                enable: (_responsive$options3 = responsive.options) === null || _responsive$options3 === void 0 ? void 0 : _responsive$options3.connectParticles
              },
              number: {
                value: options.maxParticles
              },
              move: {
                enable: true,
                speed: (_responsive$options4 = responsive.options) === null || _responsive$options4 === void 0 ? void 0 : _responsive$options4.speed
              },
              size: {
                value: (_responsive$options5 = responsive.options) === null || _responsive$options5 === void 0 ? void 0 : _responsive$options5.sizeVariations
              }
            }
          }
        };
      })
    }).then(container => {
      particles._container = container;
    });
    return particles;
  }
  destroy() {
    const container = this._container;
    container && container.destroy();
  }
  pauseAnimation() {
    const container = this._container;
    container && container.pause();
  }
  resumeAnimation() {
    const container = this._container;
    container && container.play();
  }
}